/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { DAI_ZERO_REVIEW_CROP_FIELDS } from '../fragments'

export const DAI_ZERO_REVIEW_CROPS = gql`
  ${DAI_ZERO_REVIEW_CROP_FIELDS}
  query DAIZeroReviewCrops($input: DAIZeroReviewInput!) {
    daiZeroReviewCrops(input: $input) {
      modelVersion
      modelDeployed
      totalCount
      manifestCount
      eligibleCount
      nextCursor
      crops {
        ...DAIZeroReviewCropFields
      }
    }
  }
`
